import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

function ImpressumPage() {
  const navigate = useNavigate();

  return (
    <>
      <Nav />
      <div style={{background:'#fff',padding:'80px 40px',minHeight:'100vh'}}>
        <div style={{maxWidth:760,margin:'0 auto'}}>
          <button onClick={() => navigate(-1)} style={{background:'none',border:'none',fontSize:14,color:'#aaa',cursor:'pointer',fontFamily:'inherit',marginBottom:40,display:'flex',alignItems:'center',gap:6}}>← Zurück</button>
          <h1 style={{fontSize:40,fontWeight:800,letterSpacing:'-1.5px',color:'#111',marginBottom:40}}>Impressum</h1>
          <div style={{fontSize:15,color:'#444',lineHeight:1.9}}>
            <p style={{marginBottom:24}}><strong>Angaben gemäß § 5 DDG</strong></p>
            <p style={{marginBottom:24}}>
              <strong>FrontUp</strong><br />
              Canel Sözer<br />
              Schuntertal 23<br />
              38108 Braunschweig<br />
              Deutschland
            </p>
            <p style={{marginBottom:24}}>
              <strong>Kontakt:</strong><br />
              Telefon: +49 179 1548 8222<br />
              E-Mail: hallo@frontup.eu
            </p>
            <p style={{marginBottom:24}}>
              <strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</strong><br />
              Canel Sözer, Schuntertal 23, 38108 Braunschweig
            </p>
            <hr style={{border:'none',borderTop:'1px solid #e5e5e5',margin:'32px 0'}} />
            <p style={{marginBottom:12}}><strong>Haftung für Inhalte</strong></p>
            <p style={{marginBottom:24}}>Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Bei bekannt werden von Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
            <p style={{marginBottom:12}}><strong>Haftung für Links</strong></p>
            <p style={{marginBottom:24}}>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
            <p style={{marginBottom:12}}><strong>Urheberrecht</strong></p>
            <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </div>
        </div>
      </div>
      <Footer simple />
    </>
  );
}

export default ImpressumPage;
